
import learnurl from "../assets/images/lesson-enable_icon.png";
import learnDisabledUrl from "../assets/images/lesson-disabled_icon.png";
import playurl from "../assets/images/play_enable_icon.png";
import playurlDisabled from "../assets/images/play_disable_icon.png";

export default function getSectionIconFromType(type) {
    switch (type) {
      case 'iFrame':
        return {
          enabled: learnurl,
          disabled: learnDisabledUrl,
        };
      case 'Video':
        return {
          enabled: playurl,
          disabled: playurlDisabled,
        };

      default:
        return {
          enabled: learnurl,
          disabled: learnDisabledUrl,
        };
    }
  }